import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = ['!SET_LOCALE', '!CHANGE_LOCALE', '!UPDATE_LOCALE'] as const

export default serviceActionsGenerator('locale', actionTypes)
